/**
 * lib/kundentyp.js
 * Kundentyp seçenekleri — temel liste + genişletilebilir marketplace listesi.
 * Özel eklenen tipler localStorage'da saklanır ve tüm formlarda görünür.
 */

export const KUNDENTYP_OPTIONS = ['B2B', 'Shopify', 'eBay'];

const CUSTOM_KEY = 'custom_kundentypen';

/** @returns {string[]} kayıtlı özel marketplace tipleri */
export function getCustomKundentypen() {
  try {
    const raw = localStorage.getItem(CUSTOM_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

/** Temel + özel tiplerin birleşik listesi */
export function getKundentypOptions() {
  const custom = getCustomKundentypen().filter((t) => !KUNDENTYP_OPTIONS.includes(t));
  return [...KUNDENTYP_OPTIONS, ...custom];
}

/** Yeni marketplace tipi ekler (varsa yok sayılır) */
export function addCustomKundentyp(name) {
  const trimmed = String(name || '').trim();
  if (!trimmed || KUNDENTYP_OPTIONS.includes(trimmed)) return;
  const custom = getCustomKundentypen();
  if (custom.includes(trimmed)) return;
  try {
    localStorage.setItem(CUSTOM_KEY, JSON.stringify([...custom, trimmed]));
  } catch {
    /* localStorage yoksa sessizce geç */
  }
}

/** Kundentyp rozet renkleri (tailwind sınıfları) */
export function getKundentypBadgeClass(typ) {
  switch ((typ || 'B2B').toLowerCase()) {
    case 'shopify': return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    case 'ebay': return 'bg-amber-50 text-amber-700 border-amber-200';
    case 'b2b': return 'bg-slate-100 text-slate-700 border-slate-200';
    default: return 'bg-blue-50 text-blue-700 border-blue-200';
  }
}
